/* LBS recommendations: one-tap add for .lbs-rec rows (PDP + cart drawer + cart page).
   POSTs /cart/add.js with a hidden _source property, then refreshes the Dawn cart drawer
   through the section rendering API (same flow as product-form.js). */
(() => {
  if (window.__lbsRecs) return;
  window.__lbsRecs = true;

  const live = document.createElement('p');
  live.className = 'visually-hidden';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  const mountLive = () => document.body && !live.isConnected && document.body.appendChild(live);
  mountLive() || document.addEventListener('DOMContentLoaded', mountLive);
  const announce = (msg) => {
    mountLive();
    live.textContent = '';
    setTimeout(() => (live.textContent = msg), 50);
  };

  const addUrl = () => ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  document.addEventListener('click', async (evt) => {
    const btn = evt.target.closest('[data-lbs-rec-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    const row = btn.closest('.lbs-rec');
    const err = row && row.querySelector('.lbs-rec__err');
    const labelEl = btn.querySelector('.lbs-rec__label');
    const label = labelEl ? labelEl.textContent : btn.textContent;
    const title = btn.dataset.title || 'Item';
    const drawer = document.querySelector('cart-drawer');
    const onCartPage = !!document.getElementById('main-cart-items');

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    if (labelEl) labelEl.textContent = 'Adding';
    if (err) err.hidden = true;

    const body = {
      items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _source: btn.dataset.source || 'rec' } }],
    };
    if (drawer && !onCartPage && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
    }

    try {
      const res = await fetch(addUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');

      announce(`${title} added to cart.`);
      if (onCartPage) {
        window.location.reload();
        return;
      }
      if (drawer && data.sections) {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lbs-recs', productVariantId: body.items[0].id, cartData: data });
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      if (btn.isConnected) {
        if (labelEl) labelEl.textContent = 'Added';
        btn.classList.add('is-added');
        setTimeout(() => {
          if (labelEl) labelEl.textContent = label;
          btn.classList.remove('is-added');
        }, 2500);
      }
    } catch (e) {
      if (labelEl) labelEl.textContent = label;
      if (err) {
        err.textContent = e.message;
        err.hidden = false;
      }
      announce(e.message);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
    }
  });
})();
